import { useState } from 'react';
import { Alert, Collapse } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import announcementsService from '../services/announcementsService';

const DISMISSED_KEY = 'agendario_dismissed_announcements';

function getDismissed() {
  try {
    return JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]');
  } catch {
    return [];
  }
}

function dismiss(id) {
  const current = getDismissed();
  if (!current.includes(id)) {
    sessionStorage.setItem(DISMISSED_KEY, JSON.stringify([...current, id]));
  }
}

export default function AnnouncementBanner() {
  const [closed, setClosed] = useState(false);

  const { data: announcement } = useQuery({
    queryKey: ['announcement-active'],
    queryFn: () => announcementsService.getActive(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (!announcement || closed) return null;
  if (getDismissed().includes(announcement.id)) return null;

  const handleClose = () => {
    dismiss(announcement.id);
    setClosed(true);
  };

  return (
    <Collapse in={!closed}>
      <Alert
        severity={announcement.severity || 'info'}
        onClose={handleClose}
        sx={{ borderRadius: 0, mb: 0 }}
      >
        {announcement.message}
      </Alert>
    </Collapse>
  );
}
